import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchAuthSession } from 'aws-amplify/auth'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

const addToCognitoGroup = async () => {
  try {
    const authSession = await fetchAuthSession()

    if (authSession.userSub) {
      return postRequest(`/auth/add-to-user-cognito-group?cognito_sub=${authSession.userSub}`)
    } else {
      return null
    }
  } catch (error) {
    console.error(error)
    return null
  }
}

export const useAddToCognitoGroup = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addToCognitoGroup,
    retry: 5,
    retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
    onSuccess: () => {
      queryClient.invalidateQueries(queries.auth.session)
    },
  })
}
